import type { GroupedTask, MinifiedTask } from '@gcv/shared';

import type { DecoratedTask } from '../../tasks/tasks.model';
import { isGroupedTask } from '../../tasks/tasks.model';

/** Flattens the two shapes the tasks API returns into a single row the UI can map from. */
export const getDecoratedTask = (task: MinifiedTask | GroupedTask): DecoratedTask => {
  if (isGroupedTask(task)) {
    return {
      id: '--',
      isGrouped: task.is_grouped,
      groupKey: task.group_key,
      name: task.tasks[0].title ?? '--',
      tasks: task.tasks
    };
  }

  return {
    id: task.id,
    isGrouped: undefined,
    groupKey: '',
    name: task.title ?? '--',
    tasks: [task]
  };
};
